// extracted by mini-css-extract-plugin
export default {"hitpickingMicroplate":"hitpickingMicroplate-zJNLJ","plateLabel":"plateLabel-H_oBW"};